import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconShield(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-shield_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M47,11.55a1,1,0,0,0-.58-.87C45.9,10.45,33.91,5,26,5,17.32,5,6.05,10.46,5.57,10.69a1,1,0,0,0-.56.86c0,.51-.36,12.62,4.53,21.6S25.16,46.73,25.61,46.92a1,1,0,0,0,.78,0c.45-.19,11.15-4.74,16.07-13.77S47,12.06,47,11.55ZM37.94,30.37c-3.46,6.47-11.23,9.75-11.56,9.89a1.07,1.07,0,0,1-.76,0c-.33-.14-8.1-3.42-11.57-9.89s-3.52-14-3.52-14.36a1,1,0,0,1,.52-.89c.35-.19,8.52-4.56,15-4.56s14.59,4.37,14.94,4.56a1,1,0,0,1,.53.89C41.47,16.33,41.36,24,37.94,30.37Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M31.86,13.57,16.66,30.78a18.86,18.86,0,0,0,2.66,3L35.92,15A42.22,42.22,0,0,0,31.86,13.57Z"
      }));
    }
  }));
}
export default SvgIconShield;